<div class="container">
  <mat-card>
    <form [formGroup]="productMixForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Product' | translate }}</mat-label>
            <input matInput formControlName="productId" />
          </mat-form-field>

          @if (productData) {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Restricted products' | translate }}</mat-label>
              <mat-select required formControlName="restrictedProducts" multiple>
                @for (product of productData; track product) {
                  <mat-option [value]="product.id">
                    {{ product.name }}
                  </mat-option>
                }
              </mat-select>
              @if (productMixForm.controls.restrictedProducts.hasError('required')) {
                <mat-error>
                  {{ 'labels.commons.At least one restricted product' | translate }}
                  <strong>{{ 'labels.commons.must be selected' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!productMixForm.valid"
          *LOSxHasPermission="'UPDATE_PRODUCTMIX'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
